import React from "react";
import { graphql, useFragment } from "react-relay";

import { useOpenFile } from "../../../../Files/useOpenFile";
import { useOpenImagePicker } from "../../../../../components/mobile/useImageActionSheet";
import { LinkedContentInput } from "../../../../../components/LinkedContent/LinkedContentInput";
import { Box } from "arkh";
import { useWorkspaceSignalEditRemoveFile } from "./useWorkspaceSignalEditRemoveFile";
import { useWorkspaceSignalEditRemoveImages } from "./useWorkspaceSignalEditRemoveImages";
import { WorkspaceSignalLinkedContent_signal$key } from "./__generated__/WorkspaceSignalLinkedContent_signal.graphql";

export function WorkspaceSignalLinkedContent(props: {
  signal: WorkspaceSignalLinkedContent_signal$key;
  addImage: (
    uri: string,
    { width, height }: { width: number; height: number }
  ) => void;
  openLinkFile: () => void;
  disabled: boolean;
}) {
  const signal = useFragment(
    graphql`
      fragment WorkspaceSignalLinkedContent_signal on SignalWorkspace {
        id
        descriptionImages {
          id
          ...LinkedContentInput_images
        }
        descriptionFiles {
          id
          url
          name
          type
          ...LinkedContentInput_files
        }
      }
    `,
    props.signal
  );

  const { openImagePicker } = useOpenImagePicker({
    onAddImage: props.addImage,
  });

  const removeFiles = useWorkspaceSignalEditRemoveFile();
  const removeImages = useWorkspaceSignalEditRemoveImages();
  const openFile = useOpenFile();

  return (
    <Box
      shadow="strong"
      cornerRadiusBottomLeft="large"
      cornerRadiusBottomRight="large"
    >
      <LinkedContentInput
        files={signal.descriptionFiles}
        images={signal.descriptionImages}
        openFile={openFile}
        removeFile={(id) => {
          removeFiles(signal.id, [id]);
        }}
        removeImage={(id) => {
          removeImages(signal.id, [id]);
        }}
        openLinkFile={props.openLinkFile}
        openImagePicker={openImagePicker}
        disabled={props.disabled}
      />
    </Box>
  );
}
